import { render, staticRenderFns } from "./blank-homeplace.vue?vue&type=template&id=2298f9c8"
import script from "./blank-homeplace.vue?vue&type=script&lang=js"
export * from "./blank-homeplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports